module.exports = __webpack_public_path__ + "static/media/15UN-Habitat16.76dcfdc7.jpg";